export enum enumSasFinDescription {
  'Saswitch ATM Balance Enquiry' = 'Saswitch ATM Balance Enquiry',
  'Saswitch ATM Withdrawal' = 'Saswitch ATM Withdrawal',
  'Internal Transfer From' = 'Internal Transfer From',
  'Charge Fee' = 'Charge Fee',
  'Reversal This Amount' = 'Reversal This Amount',
  'NAD Balance Enquiry'= 'NAD Balance Enquiry',
  'NAD Withdrawal'= 'NAD Withdrawal',
  'NAD External Transfer' = 'NAD External Transfer',
  'Debit Card Purchase' = 'Debit Card Purchase',
  'Saambou ACB Incoming Credits' = 'Saambou ACB Incoming Credits',
  'Third Party Payment From Account' = 'Third Party Payment From Account',
  'Third Party Payment From Deposit' = 'Third Party Payment From Deposit',
  'Debit Card Withdrawal' = 'Debit Card Withdrawal',
  'Debit Card Balance Enquiry' = 'Debit Card Balance Enquiry',
//   'Reversal New Actual Amount' = 'Reversal New Actual Amount',
  'ACB Credit Incoming' = 'ACB Credit Incoming',
  'ACB Debit Incoming' = 'ACB Debit Incoming',
  'ACB Credit Contra Incoming' = 'ACB Credit Contra Incoming',
  'ACB Debit Contra Incoming' = 'ACB Debit Contra Incoming',
  'Saambou ACB Incoming Debits' = 'Saambou ACB Incoming Debits',
  'ACB Debit Contra Incoming Saambou' = 'ACB Debit Contra Incoming Saambou',
  'ACB Credit Contra Incoming Saambou' = 'ACB Credit Contra Incoming Saambou',
  'Saambou Balance Debit' = 'Saambou Balance Debit',
  'Saambou Balance Credit' = 'Saambou Balance Credit',
  'Interim Statement' = 'Interim Statement',
  'QDI From' = 'QDI From',
  'QDI To' = 'QDI To',
  'Monthly Account Fee' = 'Monthly Account Fee',
  'ABSA Cash Deposits From' = 'ABSA Cash Deposits From',
  'Post Office Cash Deposit From' = 'Post Office Cash Deposit From',
  'Lost Card' = 'Lost Card',
  'ACB Sameday Outgoing Debit' = 'ACB Sameday Outgoing Debit',
  'Daily Credit Restriction' = 'Daily Credit Restriction',
  'Stop Order' = 'Stop Order',
  'Batch QDI From' = 'Batch QDI From',
  'Cheque Deposits' = 'Cheque Deposits',
  'Batch QDI Fee CH' = 'Batch QDI Fee CH',
  'Batch QDI Fee SP' = 'Batch QDI Fee SP',
  'Batch QDI To' = 'Batch QDI To',
  'ACB Outgoing CT' = 'ACB Outgoing CT',
  'Funds On Hold' = 'Funds On Hold',
  'Internal Transfer To' = 'Internal Transfer To',
  'Batch QDI Fee CH To' = 'Batch QDI Fee CH To',
  'Batch QDI Fee SP To' = 'Batch QDI Fee SP To',
  'Terminal Transfer To' = 'Terminal Transfer To',
  'Terminal Transfer From' = 'Terminal Transfer From',
  'Funds Released' = 'Funds Released',
  'SEDI Settlement' = 'SEDI Settlement',
//   'SEDI Card Validation' = 'SEDI Card Validation',
//   'SEDI Registration' = 'SEDI Registration',
  'MATM Withdrawal' = 'MATM Withdrawal',
  'MATM Card Validation' = 'MATM Card Validation',
  'ACB SameDay Outgoing Debit' = 'ACB SameDay Outgoing Debit',
  'NAD Settlement' = 'NAD Settlement',
  'NAD Validation' = 'NAD Validation',
//   'NAD Withdrawal' = 'NAD Withdrawal',
  'NAD Settlement TM' = 'NAD Settlement TM',
//   'NAD Balance Enquiry' = 'NAD Balance Enquiry',
  'SEDI Withdrawal' = 'SEDI Withdrawal',
  'SEDI Settlement TM' = 'SEDI Settlement TM',
  'SEDI Card Validation' = 'SEDI Card Validation',
  'SEDI Registration' = 'SEDI Registration',
  'SP Internal Transfer' = 'SP Internal Transfer',
  'NAD Balance Enquiry TM' = 'NAD Balance Enquiry TM',
  'SEDI Card Validation TM' = 'SEDI Card Validation TM',
  'SEDI Registration TM' = 'SEDI Registration TM',
  'Internet Balance Enquiry' = 'Internet Balance Enquiry',
  'Internet Internal Transfer From' = 'Internet Internal Transfer From',
  'InternetExternalTransfer' = 'InternetExternalTransfer',
  'InternetStatementFee' = 'InternetStatementFee',
  'Internet InternalTransferTo' = 'Internet InternalTransferTo',
  'Card Terminal Transfer From' = 'Card Terminal Transfer From',
  'Card Terminal Transfer To' = 'Card Terminal Transfer To',
  'ABSA Cheque Deposits From' = 'ABSA Cheque Deposits From',
  'ABSA Cheque Deposits To' = 'ABSA Cheque Deposits To',
  'ABSA Cash Deposits To' = 'ABSA Cash Deposits To',
  'Interest Paid Reversed' = 'Interest Paid Reversed',
  'Interest Paid' = 'Interest Paid',
  'Account Closures Fee' = 'Account Closures Fee',
  'Account Closures Write-Off' = 'Account Closures Write-Off',
  'Post Office Cash Deposit' = 'Post Office Cash Deposit',
  'Payrol Transfer From' = 'Payrol Transfer From',
  'Payrol Transfer To' = 'Payrol Transfer To',
  'Journal Transaction' = 'Journal Transaction',
  'Amber Value Realisation (to TEN)' = 'Amber Value Realisation (to TEN)',
  'OTC Statement Enq' = 'OTC Statement Enq',
  'Interim Statement Request' = 'Interim Statement Request',
  'Terminal Identification' = 'Terminal Identification',
  'Terminal Purchase =  Pocket' = 'Terminal Purchase , Pocket',
  'OnUs Supervisor ID From' = 'OnUs Supervisor ID From',
  'OnUs Supervisor ID To' = 'OnUs Supervisor ID To',
  'OnUs MSA Terminal Purchase From' = 'OnUs MSA Terminal Purchase From',
  'OnUs MSA Terminal Purchase To' = 'OnUs MSA Terminal Purchase To',
  'Opening Account Fee' = 'Opening Account Fee',
  'AEDO Settlement From' = 'AEDO Settlement From',
  'AEDO Settlement To' = 'AEDO Settlement To',
  'AEDO Contract Reg OU From' = 'AEDO Contract Reg OU From',
  'AEDO Contract Reg OU To' = 'AEDO Contract Reg OU To',
  'AEDO Contract Reg NoU' = 'AEDO Contract Reg NoU',
  'AEDO Contract Reg' = 'AEDO Contract Reg',
  'AEDO Deduction' = 'AEDO Deduction',
  'AEDO Receipt' = 'AEDO Receipt',
  'NAEDO Deduction' = 'NAEDO Deduction',
  'NAEDO Receipt' = 'NAEDO Receipt',
  'Terminal Mandated CR Transfer From' = 'Terminal Mandated CR Transfer From',
  'Terminal Mandated CR Transfer To' = 'Terminal Mandated CR Transfer To',
  'Mandated Credit Transfer From' = 'Mandated Credit Transfer From',
  'Mandated Credit Transfer To' = 'Mandated Credit Transfer To',
  'TMCT Contract Registration - Client' = 'TMCT Contract Registration - Client',
  'TMCT Contract Registration - Merchant' = 'TMCT Contract Registration - Merchant',
  'MCT Contract Registration - Client' = 'MCT Contract Registration - Client',
  'MCT Contract Registration - Merchant' = 'MCT Contract Registration - Merchant',
  'NAEDO Settlement - Client' = 'NAEDO Settlement - Client',
  'NAEDO Settlement - Merchant' = 'NAEDO Settlement - Merchant',
  'QDI Contract Registration - Client' = 'QDI Contract Registration - Client',
  'QDI Contract Registration - Merchant' = 'QDI Contract Registration - Merchant',
  'NAEDO Contract Registration - Client' = 'NAEDO Contract Registration - Client',
  'NAEDO Contract Registration - Merchant' = 'NAEDO Contract Registration - Merchant',
  'NAEDO Contract Registration' = 'NAEDO Contract Registration',
  'QDI Settlement - Client' = 'QDI Settlement - Client',
  'QDI Settlement - Merchant' = 'QDI Settlement - Merchant',
  'QDI Settlement (H) - Client' = 'QDI Settlement (H) - Client',
  'QDI Settlement (H) - Merchant' = 'QDI Settlement (H) - Merchant',
  'International DebitCard Purchase' = 'International DebitCard Purchase',
  'International Debit Card Withdrawal' = 'International Debit Card Withdrawal',
  'International Maestro Balance Enquiry' = 'International Maestro Balance Enquiry',
  'Telebank Balance Enq' = 'Telebank Balance Enq',
  'Telebank Statement Enq' = 'Telebank Statement Enq',
  'Card Replacement Req' = 'Card Replacement Req',
  'NAEDO Disputes' = 'NAEDO Disputes',
  'ACB Outgoing CT Settlement' = 'ACB Outgoing CT Settlement',
  'OTC Statement Refund' = 'OTC Statement Refund',
  'Daily Debit Restriction' = 'Daily Debit Restriction',
  'Portal Statement Fee' = 'Portal Statement Fee',
  'Portal Balance Enquiry' = 'Portal Balance Enquiry',
  'Portal Short Statement' = 'Portal Short Statement',
  'Portal Internal Transfer To' = 'Portal Internal Transfer To',
  'Portal Internal Transfer From' = 'Portal Internal Transfer From',
  'ACB Outgoing CT - Portal' = 'ACB Outgoing CT - Portal',
  'Cell Bank Activation' = 'Cell Bank Activation',
  'CellPhone Balance Enquiry' = 'CellPhone Balance Enquiry',
  'CellPhone Mini Statement' = 'CellPhone Mini Statement',
  'CellPhone Trf SureCard To' = 'CellPhone Trf SureCard To',
  'ACB Outgoing CT - Cellphone' = 'ACB Outgoing CT - Cellphone',
  'Cell Bank Activation via Card' = 'Cell Bank Activation via Card',
  'CellPhone Trf SureCard From' = 'CellPhone Trf SureCard From',
  'NAEDO Receipt - Sponsored CSP PF' = 'NAEDO Receipt - Sponsored CSP PF',
  'NAEDO Settlement - Sponsored CSP' = 'NAEDO Settlement - Sponsored CSP',
  'AEDO Receipt=  Payer Fee' = 'AEDO Receipt, Payer Fee',
  'NAEDO Receipt=  Payer Fee' = 'NAEDO Receipt, Payer Fee',
  'AEDO Settlement PF - Client' = 'AEDO Settlement PF - Client',
//   'AEDO Settlement PF - Merchant' = 'AEDO Settlement PF - Merchant',
  'NAEDO Settlement PF - Client' = 'NAEDO Settlement PF - Client',
  'NAEDO Settlement PF - Merchant' = 'NAEDO Settlement PF - Merchant',
  'NAEDO Receipt=  CSP Payer Fee' = 'NAEDO Receipt, CSP Payer Fee',
  'NAEDO Settlement PFee - Client' = 'NAEDO Settlement PFee - Client',
  'NAEDO Settlement - CSP' = 'NAEDO Settlement - CSP',
  'NDISPUTE' = 'NDISPUTE',
  'CellPhone USSD Fee' = 'CellPhone USSD Fee',
  'Call Centre Courier Fee' = 'Call Centre Courier Fee',
//   'NAEDO Recall' = 'NAEDO Recall',
//   'AEDO Recall' = 'AEDO Recall',
  'NAEDO Receipt=  PF Inc' = 'NAEDO Receipt, PF Inc',
  'AEDO Receipt=  PF Inc' = 'AEDO Receipt, PF Inc',
  'AEDO Receipt=  Funds Trf' = 'AEDO Receipt, Funds Trf',
  'AEDO Receipt=  Payer Fee Inc' = 'AEDO Receipt, Payer Fee Inc',
  'NAEDO Receipt=  Funds Trf' = 'NAEDO Receipt, Funds Trf',
  'NAEDO Receipt=  Payer Fee Inc' = 'NAEDO Receipt, Payer Fee Inc',
  'AEDO Settlement PF Inc - Client' = 'AEDO Settlement PF Inc - Client',
  'AEDO Settlement PF Inc - Distr Acc' = 'AEDO Settlement PF Inc - Distr Acc',
  'AEDO Settlement PF - Funds Trf' = 'AEDO Settlement PF - Funds Trf',
  'AEDO Settlement PF - Merchant' = 'AEDO Settlement PF - Merchant',
  'NAEDO Settlement PF Inc - Client' = 'NAEDO Settlement PF Inc - Client',
  'NAEDO Settlement PF Inc - Distr Acc' = 'NAEDO Settlement PF Inc - Distr Acc',
  'NAEDO Settlement PF - Funds Trf' = 'NAEDO Settlement PF - Funds Trf',
  'NAEDO Settlement PF Inc - Merchant' = 'NAEDO Settlement PF Inc - Merchant',
  'Portal Card Replacement' = 'Portal Card Replacement',
  'Card Replacement' = 'Card Replacement',
  'ACB Inc DT Rejection' = 'ACB Inc DT Rejection',
  'AEDO Receipt=  CSP Funds Trf' = 'AEDO Receipt, CSP Funds Trf',
  'NAEDO Receipt=  CSP Funds Trf' = 'NAEDO Receipt, CSP Funds Trf',
  'AEDO Settlement PF - CSP Funds Trf' = 'AEDO Settlement PF - CSP Funds Trf',
  'NAEDO Settlement PF - CSP Funds Trf' = 'NAEDO Settlement PF - CSP Funds Trf',
  'AEDO Receipt=  CSP Payer Fee Inc' = 'AEDO Receipt, CSP Payer Fee Inc',
  'NAEDO Receipt=  CSP Payer Fee Inc' = 'NAEDO Receipt, CSP Payer Fee Inc',
  'AEDO Settlement PF - CSP Merchant' = 'AEDO Settlement PF - CSP Merchant',
  'NAEDO Settlement PF - CSP Merchant' = 'NAEDO Settlement PF - CSP Merchant',
  'PMCT Contract Registration - Client' = 'PMCT Contract Registration - Client',
  'PMCT Contract Registration - Merchant' = 'PMCT Contract Registration - Merchant',
  'Portal MCT From' = 'Portal MCT From',
  'Portal MCT To' = 'Portal MCT To',
  'Swift Transfer VRIN Settlement From' = 'Swift Transfer VRIN Settlement From',
  'Swift Transfer VRIN Settlement To' = 'Swift Transfer VRIN Settlement To',
  'Direct PAN Transfer From' = 'Direct PAN Transfer From',
  'Direct PAN Transfer To' = 'Direct PAN Transfer To',
  'SMS Notification' = 'SMS Notification',
  'ABSA Electronic Deposit To' = 'ABSA Electronic Deposit To',
  'ACB Outgoing Debit Dated' = 'ACB Outgoing Debit Dated',
  'ABSA Electronic Deposit From' = 'ABSA Electronic Deposit From',
  'ACB Outgoing Debits Returned' = 'ACB Outgoing Debits Returned',
  'ACB Outgoing Debits Disputed' = 'ACB Outgoing Debits Disputed',
  'ACB Outgoing CT Returned' = 'ACB Outgoing CT Returned',
  'CellPOS Trf SureCard To' = 'CellPOS Trf SureCard To',
  'CellPOS Trf SureCard' = 'CellPOS Trf SureCard',
  'Cancel Convenience Card From' = 'Cancel Convenience Card From',
  'Cancel Convenience Card To' = 'Cancel Convenience Card To',
  'CellBank USSD Balance Enquiry' = 'CellBank USSD Balance Enquiry',
  'CellBank PAN Balance Enquiry' = 'CellBank PAN Balance Enquiry',
  'FMCT ContractRegistration - Client' = 'FMCT ContractRegistration - Client',
  'FMCTContractRegistration - Merchant' = 'FMCTContractRegistration - Merchant',
  'Fixed MCT From' = 'Fixed MCT From',
  'Fixed MCT To' = 'Fixed MCT To',
  'Device Activation' = 'Device Activation',
  'Device Initialization' = 'Device Initialization',
  'Device Authorization' = 'Device Authorization',
  'SSD Balance Enquiry Client' = 'SSD Balance Enquiry Client',
  'SSD Balance Enquiry Merchant' = 'SSD Balance Enquiry Merchant',
  'SSD Balance Enquiry - OffUs' = 'SSD Balance Enquiry - OffUs',
  'SSD Withdrawal Client' = 'SSD Withdrawal Client',
  'SSD Withdrawal Merchant' = 'SSD Withdrawal Merchant',
  'SSD Withdrawal - OffUs' = 'SSD Withdrawal - OffUs',
  'NAEDO Registration Client' = 'NAEDO Registration Client',
  'NAEDO Registration Merchant' = 'NAEDO Registration Merchant',
  'NAEDO Registration - OffUs' = 'NAEDO Registration - OffUs',
  'AEDO Registration Client' = 'AEDO Registration Client',
  'AEDO Registration Merchant' = 'AEDO Registration Merchant',
  'AEDO Registration - OffUs' = 'AEDO Registration - OffUs',
  'SASSA Distribution - Office' = 'SASSA Distribution - Office',
  'SASSA Distribution - Merchant' = 'SASSA Distribution - Merchant',
  'Reversal New Actual Amount' = 'Reversal New Actual Amount',
  'SASSA Dispute - Merchant' = 'SASSA Dispute - Merchant',
  'SASSA Dispute - Office' = 'SASSA Dispute - Office',
  'AEDO Recall' = 'AEDO Recall',
  'NAEDO Recall' = 'NAEDO Recall',
  'AirTime Purchase - Client' = 'AirTime Purchase - Client',
  'AirTime Purchase - Supplier' = 'AirTime Purchase - Supplier',
  'Electricity Purchase - Supplier' = 'Electricity Purchase - Supplier',
  'Electricity Purchase - Client' = 'Electricity Purchase - Client',
  'Wizzit Clients Debits' = 'Wizzit Clients Debits',
  'Wizzit Clients Credits' = 'Wizzit Clients Credits',
  'Wizzit Clients Zero' = 'Wizzit Clients Zero',
  'Facility Reset - Supplier' = 'Facility Reset - Supplier',
  'Facility Reset - Client' = 'Facility Reset - Client',
  'Send OTP' = 'Send OTP',
  'Token Presentment To' = 'Token Presentment To',
  'Token Presentment From' = 'Token Presentment From',
  'Pocket Load From' = 'Pocket Load From',
  'Pocket Load To' = 'Pocket Load To',
  '3rd Party Transfer From' = '3rd Party Transfer From',
  '3rd Party Transfer To' = '3rd Party Transfer To',
  '3rd Party External Transfer' = '3rd Party External Transfer',
  'Amber Value Realisation (To GL)' = 'Amber Value Realisation (To GL)',
  'Swift Transfer VROUT Settlement From' = 'Swift Transfer VROUT Settlement From',
  'Swift Transfer VROUT Settlement To' = 'Swift Transfer VROUT Settlement To',
  '3rd Party Direct PAN Transfer From' = '3rd Party Direct PAN Transfer From',
  '3rd Party Direct PAN Transfer To' = '3rd Party Direct PAN Transfer To',
  'Funds On Hold To Be Authorized' = 'Funds On Hold To Be Authorized',
  'ACB Inc CT Rejection' = 'ACB Inc CT Rejection',
  'SWIFT Incoming' = 'SWIFT Incoming',
  'SWIFT Incoming Rejection' = 'SWIFT Incoming Rejection',
  'Account Closure with Fee' = 'Account Closure with Fee',
  'Local MC Debit Card Bal Enq' = 'Local MC Debit Card Bal Enq',
  'Local MC ATM Balance Enquiry' = 'Local MC ATM Balance Enquiry',
  'Local MC ATM Withdrawal' = 'Local MC ATM Withdrawal',
  'Local MC Debit Card Purchase' = 'Local MC Debit Card Purchase',
  'Reservation Of Funds' = 'Reservation Of Funds',
  'DC TT1 RT Contract Registration' = 'DC TT1 RT Contract Registration',
  'DC TT1 DL Contract Registration' = 'DC TT1 DL Contract Registration',
  'DC TT2 Contract Registration' = 'DC TT2 Contract Registration',
  'DC TT3 Contract Registration' = 'DC TT3 Contract Registration',
  'DC OnUs Contract Registration To' = 'DC OnUs Contract Registration To',
  'DebiCheck TT1 Cancellation' = 'DebiCheck TT1 Cancellation',
  'DebiCheck TT1 RT Amendment' = 'DebiCheck TT1 RT Amendment',
  'DebiCheck TT2 Amendment' = 'DebiCheck TT2 Amendment',
  'DebiCheck Recall ' = 'DebiCheck Recall ',
  'DebiCheck Dispute' = 'DebiCheck Dispute',
  'DebiCheck Suspension' = 'DebiCheck Suspension',
  'DebiCheck Receipt' = 'DebiCheck Receipt',
  'DebiCheck OU Settlement From' = 'DebiCheck OU Settlement From',
  'DC OnUs Contract Registration From' = 'DC OnUs Contract Registration From',
  'Debicheck OU Settlement To' = 'Debicheck OU Settlement To',
  'DC Debit Response Incl PF' = 'DC Debit Response Incl PF',
  'DC Clearing OffUs Incl PF From' = 'DC Clearing OffUs Incl PF From',
  'DC Clearing OffUs Incl PF To' = 'DC Clearing OffUs Incl PF To',
  'DC Clearing OffUs Incl CSP From' = 'DC Clearing OffUs Incl CSP From',
  'DC Clearing OffUs Incl CSP To' = 'DC Clearing OffUs Incl CSP To',
  'DC OU Settlement Incl PF Client' = 'DC OU Settlement Incl PF Client',
  'DC OU Settlement Incl PF Dis Acc' = 'DC OU Settlement Incl PF Dis Acc',
  'DC Clearing OU Settlement PF F TRF' = 'DC Clearing OU Settlement PF F TRF',
  'DC Clearing OU Settlement PF Mercha' = 'DC Clearing OU Settlement PF Mercha',
  'DC Clearing OU Settlement CSP F TRF' = 'DC Clearing OU Settlement CSP F TRF',
  'DC Clearing OU Settlement CSP Merch' = 'DC Clearing OU Settlement CSP Merch',
  'ABSA Cardless ATM Cash deposits fro' = 'ABSA Cardless ATM Cash deposits fro',
  'ABSA CARDLESS ATM DEPOSIT To' = 'ABSA CARDLESS ATM DEPOSIT To',
  'EFT SystemError Credit Request' = 'EFT SystemError Credit Request',
  'EFT SystemError Debit Request' = 'EFT SystemError Debit Request',
  'EFT SystemError Credit NonFin Res' = 'EFT SystemError Credit NonFin Res',
  'EFT SystemError Debit NonFin Res' = 'EFT SystemError Debit NonFin Res',
  'EFT SystemError Credit SAMEDAY' = 'EFT SystemError Credit SAMEDAY',
  'EFT SystemError Debit SAMEDAY' = 'EFT SystemError Debit SAMEDAY',
  'Homing EFT SystemError Credit Req' = 'Homing EFT SystemError Credit Req',
  'Homing EFT SystemError Debit Req' = 'Homing EFT SystemError Debit Req',
  'Homing EFT SEC Credit NonFin Res' = 'Homing EFT SEC Credit NonFin Res',
  'Homing EFT SEC Debit NonFin Res' = 'Homing EFT SEC Debit NonFin Res',
  'Homing EFT SEC Credit Res SAMEDAY' = 'Homing EFT SEC Credit Res SAMEDAY',
  'Homing EFT SEC Debit Res SAMEDAY' = 'Homing EFT SEC Debit Res SAMEDAY',
  '3rd Party Transfer PartiallyFrom' = '3rd Party Transfer PartiallyFrom',
  '3rd Party Transfer Partially To' = '3rd Party Transfer Partially To',
  '3rd Party External Transfer Partial' = '3rd Party External Transfer Partial',
  'Funds On Hold To Be Authorized PA' = 'Funds On Hold To Be Authorized PA',
  'DC Debtor TT1 RT Contract Reg' = 'DC Debtor TT1 RT Contract Reg',
  'DC Debtor TT1 DL Contract Reg' = 'DC Debtor TT1 DL Contract Reg',
  'DC Debtor TT2 Contract Reg' = 'DC Debtor TT2 Contract Reg',
  'DC Debtor TT3 Contract Reg' = 'DC Debtor TT3 Contract Reg',
  'Not in Use' = 'Not in Use',
  'DC Debtor TT2 Cancellation' = 'DC Debtor TT2 Cancellation',
  'DC Debtor TT1 RT Amendment' = 'DC Debtor TT1 RT Amendment',
  'DC Debtor TT2 Amendment' = 'DC Debtor TT2 Amendment',
  'DC Debtor Recall' = 'DC Debtor Recall',
  'DC Debtor Disputes' = 'DC Debtor Disputes',
  'DC Debtor Suspension' = 'DC Debtor Suspension',
  'DC Debtor Deduction' = 'DC Debtor Deduction',
  'RTC Debit Send Funds' = 'RTC Debit Send Funds',
  'RTC Credit Received Funds' = 'RTC Credit Received Funds',
  'eCommerce Debit Local' = 'eCommerce Debit Local',
  'RTC Credit Balance Enq' = 'RTC Credit Balance Enq',
  'eCommerce Debit International' = 'eCommerce Debit International',
  'Contactless Tap and Pay Local' = 'Contactless Tap and Pay Local',
  'Contactless Tap and Pay Int' = 'Contactless Tap and Pay Int',
  'eCommerce With 3DSecure Local' = 'eCommerce With 3DSecure Local',
  'eCommerce With 3DSecure Int' = 'eCommerce With 3DSecure Int',
  'POS Purchase with CashBack' = 'POS Purchase with CashBack',
  'EMV Recurring Payment' = 'EMV Recurring Payment',
  'ECommerceWithPIN' = 'ECommerceWithPIN',
  'Contactless Without PIN TP Local' = 'Contactless Without PIN TP Local',
  'Contactless Without PIN TP Int' = 'Contactless Without PIN TP Int',
  'AmberAgent Mini Statement' = 'AmberAgent Mini Statement',
  'Swift Incoming HV' = 'Swift Incoming HV',
  'RTC Funds On Hold' = 'RTC Funds On Hold',
  'Local MC Debit Card On Hold' = 'Local MC Debit Card On Hold',
  'eCommerce Debit Local On Hold' = 'eCommerce Debit Local On Hold',
  'eCommerce Debit Int On Hold' = 'eCommerce Debit Int On Hold',
  'Contactless Tap and Pay Loc On Hold' = 'Contactless Tap and Pay Loc On Hold',
  'Contactless Tap and Pay Int On Hold' = 'Contactless Tap and Pay Int On Hold',
  'POS Purchase with CashBack On Hold' = 'POS Purchase with CashBack On Hold',
  'EMV Recurring Payment On Hold' = 'EMV Recurring Payment On Hold',
  'Contactless WO PIN TP Loc On Hold' = 'Contactless WO PIN TP Loc On Hold',
  'Contactless WO PIN TP Int On Hold' = 'Contactless WO PIN TP Int On Hold',
  'ATM Contactless Local' = 'ATM Contactless Local',
  'ATM Contactless Int' = 'ATM Contactless Int',
  'ECommerceWithPIN On Hold' = 'ECommerceWithPIN On Hold',
  'International DebitCard POS On Hold' = 'International DebitCard POS On Hold',
  'International POS Purchase Dual' = 'International POS Purchase Dual',
  'Local MC Debit Card Purchase Dual' = 'Local MC Debit Card Purchase Dual',
  'POS Purchase with CashBack Dual' = 'POS Purchase with CashBack Dual',
  'ECommerceWithPIN Dual' = 'ECommerceWithPIN Dual',
  'Mobile App Activation' = 'Mobile App Activation',
  'Settlement 3rd Party Transfer From' = 'Settlement 3rd Party Transfer From',
  'Settlement 3rd Party Transfer To' = 'Settlement 3rd Party Transfer To',
  'Multiple Third Party Transfer From' = 'Multiple Third Party Transfer From',
  'Multiple Third Party Transfer To' = 'Multiple Third Party Transfer To',
  'DC Settlement' = 'DC Settlement',
  'DC Response Generic Transfer From' = 'DC Response Generic Transfer From',
  'DC Response Generic Transfer To' = 'DC Response Generic Transfer To',
  'DC Settlement Incl PF' = 'DC Settlement Incl PF',
  'DC Response PF Generic Transfer Fro' = 'DC Response PF Generic Transfer Fro',
  'DC Response PF Generic Transfer To' = 'DC Response PF Generic Transfer To',
  'DC OU Settlement From' = 'DC OU Settlement From',
  'DC OU Settlement To' = 'DC OU Settlement To',
  'DC OU Respone Generic Transfer From' = 'DC OU Respone Generic Transfer From',
  'DC OU Respone Generic Transfer To' = 'DC OU Respone Generic Transfer To',
}

export namespace enumSasFinDescription {
  export function values() {
    return Object.keys(enumSasFinDescription).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}